/* @flow */

import React from 'react';
import Immutable from 'immutable';
import uuid from 'uuid';
import { Message } from 'semantic-ui-react';
import NavigationLinksHeader from './NavigationLinksHeader';
import NavigationLinkItem from './NavigationLinkItem';
import { reorderElements, enforceElementsOrder } from 'utils/ordering';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  links: Array<NavigationContentLink>,
  resourceStrategy: ResourceStrategy,
  onAdd: (link: NavigationContentLink) => void,
  onUpdate: (links: Array<NavigationContentLink>) => void,
};

const sortedLinks = links =>
  Immutable.Seq(links).sortBy(l => l.order).toArray();

const updateLinks = links => updateFunction =>
  updateFunction(Immutable.Map(links.map(l => [l.order, l]))).toArray();

const mergeLinks = (links, updated) =>
  updateLinks(links)(map =>
    map.update(updated.order, l => ({
      ...l,
      ...updated,
    }))
  );

const removeLink = (links, toDelete) =>
  updateLinks(links)(map => map.remove(toDelete.order));

const NavigationLinks = ({
  links,
  resourceStrategy,
  onAdd,
  onUpdate,
}: Props) => {
  const renderContent = () => {
    if (links.length) {
      const updateLink = link => onUpdate(mergeLinks(links, link));

      const deleteLink = link => {
        const reordered = enforceElementsOrder(removeLink(links, link));
        onUpdate(reordered.toArray());
      };

      const reorderLinks = (link, order) => {
        const reordered = reorderElements(links, link, order);
        onUpdate(reordered.toArray());
      };

      return sortedLinks(links).map(l => (
        <NavigationLinkItem
          key={l.order}
          link={l}
          linkCount={links.length}
          defaultResourceStrategy={resourceStrategy}
          onUpdate={updateLink}
          onReorder={reorderLinks}
          onDelete={deleteLink}
        />
      ));
    }

    return (
      <Message
        attached="bottom"
        icon="blind"
        header="Aucune liaison configurée pour cette page"
      />
    );
  };

  const addLink = (page: CatalogPage) =>
    onAdd({
      id: uuid(),
      order: links.length,
      page: page,
      pageId: page.id,
      title: page.name,
    });

  return (
    <div>
      <NavigationLinksHeader onPageSelected={addLink} />
      {renderContent()}
    </div>
  );
};

export default NavigationLinks;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinks.js